export { DMS_MODULE } from '../constants';
export const NAME = 'Povzaloha';
export const CRUMB_LABEL_KEY = 'edtPOVZaloha';
